<div class="flex flex-col w-full h-full items-center justify-start gap-4">

    <div class="text-4xl">
        Result data : 
    </div>
    <div class="flex flex-col gap-3">
        {{result | json}}
    </div>
    <div class="text-4xl">
        Result error : 
    </div>
    <div class="flex flex-col gap-3">
        {{resultError | json}}
    </div>
</div>
